import React from "react";
import { DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { YesNoAnswer } from "../../../incidentLog/IncidentLogDialog.types.ts";
import IncidentLogYesNoAnswerField from "./IncidentLogYesNoAnswerField.tsx";
import { showsRepresentativeName } from "./incidentLogRequestMadeThroughRepresentativeVisibility.ts";

export interface IncidentLogRequestMadeThroughRepresentativeFieldProps {
    answer?: YesNoAnswer | null;
    representativeName?: string;
    onAnswerChange: (answer: YesNoAnswer) => void;
    onRepresentativeNameChange: (representativeName: string) => void;
    isPreview: boolean;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogRequestMadeThroughRepresentativeField(props: IncidentLogRequestMadeThroughRepresentativeFieldProps) {
    const { translateString } = useTranslation();

    return (
        <>
            <IncidentLogYesNoAnswerField
                label={translateString("requestMadeThroughRepresentative")}
                answer={props.answer}
                onChange={props.onAnswerChange}
                disabled={props.disabled}
                errorText={props.errorText}
            />
            {showsRepresentativeName(props.answer, props.isPreview) && (
                <DotLegalTextField
                    label={translateString("representativeName")}
                    value={props.representativeName ?? ""}
                    debounce
                    onChange={props.onRepresentativeNameChange}
                    disabled={props.disabled}
                />
            )}
        </>
    );
}

export default IncidentLogRequestMadeThroughRepresentativeField;
